export default "__VITE_ASSET__jS4LD8$q__"